<!-- eslint-disable vue/no-mutating-props -->
<template>

 


<div class="nk-block-head">
  <div class="nk-block-head-content">
    <h5 class="nk-block-title" v-if="formIslem === 'ekle'">Yeni Firma  Ekle</h5>
    <h5 class="nk-block-title" v-if="formIslem === 'duzenle'">Firma  Düzenleme</h5>
    <div class="nk-block-des"><p>Firmalar</p></div>
  </div>
</div>

  <form @submit.prevent="gonder">

    <div class="row">
   
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.unvan }">
        <div class="col-lg-3">
          <label for="unvan" class="form-label">Ünvan</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="unvan" v-model="localFormData.unvan" >
        <span v-if="formHatalar.unvan" class="error">{{ formHatalar.unvan }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.telefon }">
        <div class="col-lg-3">
          <label for="telefon" class="form-label">Telefon</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="telefon" v-model="localFormData.telefon" >
        <span v-if="formHatalar.telefon" class="error">{{ formHatalar.telefon }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.email }">
        <div class="col-lg-3">
          <label for="email" class="form-label">E-mail</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="email" v-model="localFormData.email" >
        <span v-if="formHatalar.email" class="error">{{ formHatalar.email }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.adres }">
        <div class="col-lg-3">
          <label for="adres" class="form-label">Adres</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="adres" v-model="localFormData.adres" >
        <span v-if="formHatalar.adres" class="error">{{ formHatalar.adres }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.not }">
        <div class="col-lg-3">
          <label for="not" class="form-label">Not</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="not" v-model="localFormData.not" >
        <span v-if="formHatalar.not" class="error">{{ formHatalar.not }}</span>
        </div>
      </div>
    
        <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.ulke }">
        <div class="col-lg-3">
          <label for="ulke" class="form-label">Ülke</label> 
        </div>
        <div class="col-lg-9">
        <input class="form-control"  id="ulke" v-model="localFormData.ulke" >
        <span v-if="formHatalar.ulke" class="error">{{ formHatalar.ulke }}</span>
        </div>
      </div>
    
    
    
    

      <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.etkinlik }">
        <div class="col-lg-3">
          <label for="etkinlik" class="form-label">Etkinlik</label> 
        </div>
        <div class="col-lg-9">
          <v-select
          v-model="localFormData.etkinlik"
          :options="etkinlikler"
          label="ad"
          :reduce="etkinlik => etkinlik.id"
          placeholder="Etkinlik Seçin"
        />
        <span v-if="formHatalar.etkinlik" class="error">{{ formHatalar.etkinlik }}</span>
        </div>
      </div>

    
    
    
    <div class="col-12 mb-1 mt-2" :class="{ 'text-danger': formHatalar.logo }"> 
       
        <picture-input 
          ref="profil"
          width="600" 
          height="600" 
          margin="16" 
          accept="image/jpeg,image/png" 
          size="10" 
          button-class="btn"
          :custom-strings="{
            upload: '<h1>Logo</h1>',
            drag: 'Tıklayın veya sürükleyip bırakın'
          }"
          @change="logoDegistir">
        </picture-input>
      </div>	
        <span v-if="formHatalar.logo" class="error">{{ formHatalar.logo }}</span>
   
    
    
     <div class="row align-items-center mt-2"  :class="{ 'text-danger': formHatalar.dosyalar }">
        <div class="col-lg-3">
          <label for="dosyalar" class="form-label">Dsoyalar</label> 
        </div>
        <div class="col-lg-9">
          <MultiFileCompenent :seciliDosyalar="seciliDosyalar" :yuklenmisDosyalar="yuklenmisDosyalar" :tabloid="localFormData.id"  @dosya-islem="seciliDosyalarDegistir"  @dosya-sil-islem="yukluDosyalarSil"></MultiFileCompenent>
              
      
        <span v-if="formHatalar.dosyalar" class="error">{{ formHatalar.dosyalar }}</span>
        </div>
      </div>
    
    

     
    </div>

    
    <div  class="col-12" v-if="isUploading">
      {{ uploadFileNmae }} Dosyası Yükleniyor
    
      <div class="progress" >
          <div class="progress-bar" role="progressbar" :style="{ width: `${uploadProgress}%` }">
            {{ uploadProgress }}%
        </div>
      </div>

    </div>
    


 

    <div class="d-flex justify-content-around  mt-4"> 
      
      <button type="button" class="btn btn-light  mr-2" @click="iptalEt"><em class="icon ni ni-cross"></em><span>İptal Et</span></button>
      <button type="submit" class="btn btn-primary"><em class="icon ni ni-check"></em><span>Kaydet</span></button>
    </div>
  </form>

</template>

<script>
import axiosCustom from "@/services/axiosCustom";

import vSelect from "vue-select";




import PictureInput from 'vue-picture-input'


import MultiFileCompenent from "@/components/anasayfa/MultiFileCompenent.vue";




export default {
components: {
  
      vSelect,
  
  
  
    PictureInput,
  
  
    MultiFileCompenent,
  
  
  
},
props: {
  formIslem: String,
  formData: Object,
  formKaydetSonrasi: Function,
  formIptal: Function,

},
data() {
  return {
    
    logoSecili: null,
    
    
  etkinlikler: [],
  
  

  
    localFormData: { ...this.formData }, 
    formHatalar:{},

    
    seciliDosyalar:[],
    yuklenmisDosyalar:[],

    isUploading: false,
    uploadProgress: 0,
    uploadFileName:'',
    

  };
},
created() {
  
  this.etkinliklerGetir();
  
   

  
  this.yuklenmisDosyalarGetir();
  
},
watch: {
      formData: {
        handler(newFormData) {
          this.localFormData = { ...newFormData };

  
          
          
          
         
          
        },
        immediate: true, // Component oluşturulduğunda da tetikle
      },
    },
methods: {
  
  async etkinliklerGetir() {
    try {
      const response = await axiosCustom.get("etkinlikler"); 
      this.etkinlikler = response.data;
    } catch (error) {
      console.error("etkinlikler alma hatası: ", error);
    }
  },
  
  



  formDogrula() {
    this.formHatalar = {};
    var kontrol=true;
    
    
    if (!this.localFormData.unvan) {
      this.formHatalar.unvan = "Ünvan boş bırakılamaz.";
      kontrol=false;
    }
    
    
     
    
     
    
     
    
     
    
     
    
  
  
  
   
  
   
 


    return kontrol;
  },
  async  gonder() {
    if(this.formDogrula()){
  // FormData oluştur
  const newFormData = new FormData();
  newFormData.append("unvan", this.localFormData.unvan ?? '');
  newFormData.append("telefon", this.localFormData.telefon ?? '');
  newFormData.append("email", this.localFormData.email ?? '');
  newFormData.append("adres", this.localFormData.adres ?? '');
  newFormData.append("not", this.localFormData.not ?? '');
  newFormData.append("ulke", this.localFormData.ulke ?? '');
  
  
  newFormData.append("etkinlik", this.localFormData.etkinlik ?? '');
   
  newFormData.append("logo",  this.logoSecili);
  

  try {
  if (this.formIslem === "duzenle") {
    axiosCustom
      .post("firmalar/duzenle/" + this.localFormData.id, newFormData)
      .then((response) => {
        
        this.cokluDosyalarYukle(response.data.id);
        

        this.$toast.success("Firma Düzenlendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Güncelleme hatası: ", error);
        this.$toast.error("Güncelleme hatası");
      });
  } else {
    axiosCustom
      .post("firmalar/ekle", newFormData)
      .then((response) => {
        
        this.cokluDosyalarYukle(response.data.id);
        

        this.$toast.success("Yeni Firma Eklendi");
        this.formKaydetSonrasi();
      })
      .catch((error) => {
        console.error("Ekleme hatası: ", error);
        this.$toast.error("Ekleme hatası");
      });
  }
} catch (error) {
    console.error('Kaydetme hatası: ', error);
    this.$toast.error('Kaydetme hatası');
  }
} 
  },
  
  iptalEt() {
    this.formIptal();
  },

  
  async yuklenmisDosyalarGetir() {
      try {
        const response = await axiosCustom.get("firmalar/dosyalar");
        this.yuklenmisDosyalar = response.data;
      } catch (error) {
        console.error("dosya alma hatası: ", error);
      }
    },

  seciliDosyalarDegistir({ files, index, type }) {
    if (type === "ekle") {
      for (let i = 0; i < files.length; i++) {
        this.seciliDosyalar.push(files[i]);
      }
    } else if (type === "kaldır") {
      this.seciliDosyalar.splice(index, 1);
    }
  },

    async cokluDosyalarYukle(id) {
    const CHUNK_SIZE = 1024 * 1024; // 1 MB

    for (const file of this.seciliDosyalar) {
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

        for (let chunk = 0; chunk < totalChunks; chunk++) {
            const start = chunk * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, file.size);

            const chunkData = file.slice(start, end);

            let formData = new FormData();
            formData.append("fileName", file.name);
            this.uploadFileName = file.name;
            formData.append("fileChunk", chunkData);
            formData.append("currentChunk", chunk);
            formData.append("totalChunks", totalChunks);

            try {
                await axiosCustom.post("firmalar/dosyalaryukle/" + id, formData);
                this.isUploading = true;
            
                this.uploadProgress = (chunk * totalChunks) / 100;
            } catch (error) {
                console.error('dosyalar yükleme hatası: ', error);
                this.$toast.error('dosyalar yükleme hatası');
                // Handle error
                return;
            }
        }
    }

    // Tüm dosyaların tüm chunk'ları yüklendiyse, işlemi tamamla
    this.isUploading = false;
    this.uploadProgress = 100;
    },

      async yukludosyalarSil(id) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post("firmalar/dosyalarsil/" + id);
          this.$toast.success("Dosyalar Silindi");
          this.yuklenmisDosyalarGetir();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast.error("Silme hatası");
        }
      }
    },

  

  
  logoDegistir(event) {
        // Dosya seçildiğinde bu metod çağrılır
        this.logoSecili = event.target.files[0];

        // Resmin önizlemesini gösterme
        if (this.logoSecili) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.logoOnizleme = e.target.result;
            };

            reader.readAsDataURL(this.logoSecili);
        }
    },
    
},
};
</script>